import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ParentSections.css';

const ParentSectionCourses = () => {
  const { t } = useTranslation('parent');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [filterLevel, setFilterLevel] = useState('all');

  const courses = [
    {
      id: 1,
      title: 'English Basics',
      category: 'Language',
      level: 'Beginner',
      description: 'Fundamental English language skills for young learners',
      duration: '10 hours',
      price: 19.99,
      image: 'https://via.placeholder.com/300x200/667eea/ffffff?text=English+Basics'
    },
    {
      id: 2,
      title: 'Grammar Fundamentals',
      category: 'Language',
      level: 'Intermediate',
      description: 'Essential grammar rules and practice exercises',
      duration: '15 hours',
      price: 24.99,
      image: 'https://via.placeholder.com/300x200/667eea/ffffff?text=Grammar'
    },
    {
      id: 3,
      title: 'Vocabulary Builder',
      category: 'Language',
      level: 'Beginner',
      description: 'Expand vocabulary through interactive activities',
      duration: '8 hours',
      price: 17.99,
      image: 'https://via.placeholder.com/300x200/667eea/ffffff?text=Vocabulary'
    },
    {
      id: 4,
      title: 'Reading Comprehension',
      category: 'Language',
      level: 'Intermediate',
      description: 'Improve reading skills with engaging stories',
      duration: '12 hours',
      price: 22.99,
      image: 'https://via.placeholder.com/300x200/667eea/ffffff?text=Reading'
    }
  ];

  const filteredCourses = courses.filter(course => {
    const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         course.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'all' || course.category === filterCategory;
    const matchesLevel = filterLevel === 'all' || course.level === filterLevel;
    return matchesSearch && matchesCategory && matchesLevel;
  });

  return (
    <div className="parent-main-content">
      <div className="parent-content-header">
        <h1 className="parent-content-title">{t('courses.title')}</h1>
        <p className="parent-content-subtitle">{t('courses.subtitle')}</p>
      </div>

      {/* Search and Filters */}
      <div className="parent-section">
        <div className="parent-filters">
          <div className="parent-search-box">
            <i className="material-icons">search</i>
            <input
              type="text"
              placeholder={t('courses.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <select
            className="parent-filter-select"
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
          >
            <option value="all">{t('courses.allCategories')}</option>
            <option value="Language">{t('courses.language')}</option>
            <option value="Math">{t('courses.math')}</option>
            <option value="Science">{t('courses.science')}</option>
          </select>

          <select
            className="parent-filter-select"
            value={filterLevel}
            onChange={(e) => setFilterLevel(e.target.value)}
          >
            <option value="all">{t('courses.allLevels')}</option>
            <option value="Beginner">{t('courses.beginner')}</option>
            <option value="Intermediate">{t('courses.intermediate')}</option>
            <option value="Advanced">{t('courses.advanced')}</option>
          </select>
        </div>
      </div>

      {/* Courses Grid */}
      <div className="parent-section">
        {filteredCourses.length === 0 ? (
          <div className="parent-empty-state">
            <i className="material-icons">school</i>
            <p>{t('courses.noCourses')}</p>
          </div>
        ) : (
          <div className="parent-courses-grid">
            {filteredCourses.map((course) => (
              <div key={course.id} className="parent-course-card">
                <div className="parent-course-image">
                  <img src={course.image} alt={course.title} />
                </div>
                <div className="parent-course-content">
                  <div className="parent-course-badges">
                    <span className="parent-course-badge">{course.category}</span>
                    <span className="parent-course-badge">{course.level}</span>
                  </div>
                  <h3 className="parent-course-title">{course.title}</h3>
                  <p className="parent-course-description">{course.description}</p>
                  <div className="parent-course-meta">
                    <span className="parent-course-duration">
                      <i className="material-icons">schedule</i>
                      {course.duration}
                    </span>
                    <span className="parent-course-price">${course.price}</span>
                  </div>
                  <button className="parent-btn primary">
                    {t('courses.viewDetails')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentSectionCourses;









